import { render } from "./Detectioncou.vue?vue&type=template&id=c3c8f888"
import script from "./Detectioncou.vue?vue&type=script&lang=js"
export * from "./Detectioncou.vue?vue&type=script&lang=js"

import "./Detectioncou.vue?vue&type=style&index=0&id=c3c8f888&lang=scss"

import exportComponent from "/Users/user/Desktop/prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__